import React from 'react';

import { Photo } from '@travel/icons/ui';
import { cx, isNotEmptyArray } from '@travel/utils';

import Media from 'components/Media';

import { EMPTY_ARRAY } from 'constants/defaultValue';
import { Translate } from 'core/translate';
import type { Media as MediaType } from 'ProviderInformation-Types';
import times from 'utils/times';

import styles from './thumbnailList.module.scss';

const TIMES_LIMIT = 7;

type Props = {
  /** on what parent page this component lives */
  onPage: 'providerInfoUndated' | 'providerInfoDated';
  className?: string;
  imgClassName?: string;
  /** Media list to be rendered as thumbnail items */
  media?: Array<MediaType>;
  /** Flag to identify if display see all photos label */
  isDisplaySeeAllPhotos?: boolean;
  onClick: (index: number) => () => void;
};

function SeeAllPhotos({ count }: { count?: number }) {
  return (
    <div className={styles.seeAllPhotos} data-testid="thumbnailList-seeAllPhotos">
      <Photo color={'white'} size={24} className={styles.icon} />
      <Translate
        id="Provider_Info.Provider_Details.View_All"
        className={styles.label}
        data={{ number_of_pictures: count }}
      />
    </div>
  );
}

function ThumbnailList(props: Props) {
  const { className, media, isDisplaySeeAllPhotos, onClick } = props;

  const photos = isNotEmptyArray(media) ? media : EMPTY_ARRAY;

  const lastPhotoIndex = photos.length > TIMES_LIMIT ? TIMES_LIMIT - 1 : photos.length - 1;

  return (
    <>
      <div data-testid="thumbnailList-wrapper" className={cx(className, styles.wrapper)}>
        {times(TIMES_LIMIT, index => (
          <button
            key={`thumbnail-${index}`}
            className={cx(styles.thumbnail, index === 0 && styles.firstThumbnail)}
            data-testid={`thumbnailList-thumbnail${index + 1}-button`}
            onClick={onClick(index < photos.length ? index % photos.length : -1)}
          >
            <Media
              media={photos[index]}
              isDisableLazyload
              isMediaOnly
              sizes={index === 0 ? '40vw' : '20vw'}
            />
            {isDisplaySeeAllPhotos &&
              !(photos.length < TIMES_LIMIT) &&
              lastPhotoIndex === index && <SeeAllPhotos count={photos.length} />}
          </button>
        ))}
      </div>
    </>
  );
}

export default ThumbnailList;
